var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { LiveScoreStatusType } from "../../definitions/constants/event-status-type.constant";
import { useForceUpdate } from "../../lib/misc.functions";
import { marketCategories } from "../../definitions/constants/market-categories.constant";
import { eventDetailSubject, eventMapping, eventUpdateSubject, marketIdMapping, marketMapping, } from "../../store/sportsbook.store";
import { getEvent } from "../../services/societyWon.services";
import { getFromLanguageFile, isMobileView } from "../../app";
import { betSlipActionSubject } from "../../store/betslip.store";
import { useTranslation } from "react-i18next";
import { checkAndAddHighLightedMarkets, compireEventKeys, compireMarketKeys, fillHighLightedMarkets, isHalfNumber } from "../../services/sportsbook.services";
import "./new-eventdetail.css";
import { Odd } from "./components/odd";
export var eventDetailVisiblity = { visible: false };
var event = false;
var updateTimer;
var MARKET_ORDER = [
    5498,
    5518,
    10435,
    5499,
    5500,
    5508,
    8967,
    10591,
    5506,
    12553,
    5516,
    5517,
    8966,
    5504,
    5507,
    5501,
    5502,
    5515,
    11212,
    10820,
    9934,
    11962,
    8696,
    8699,
    10616,
    10617,
    9056,
    7642,
    7643,
    5512,
    5511,
    11056,
    11057,
    8717,
    8716,
    8973,
    8974,
    10839,
    8710,
    8709,
    8985,
    8984,
    8989,
    11583,
    11584,
    10378,
    8705,
    8707,
    8970,
    10960,
    14491,
    11561,
    5519,
    8962,
    5520,
    6498,
    6499,
    7648,
    8718,
    8713,
    8711,
    10379,
    6505,
    6598,
    11563,
    10831,
    8963,
    8725,
    11536,
    11537,
    11546,
    10377,
    8719,
    8728,
    8712,
    8715,
    151205,
    13749,
    13748,
    10152,
    14453,
    178083,
    13377,
    6517,
    8703,
    11897,
    11898,
    10381,
    14301,
    152052,
    8722,
    11916,
    6506,
    10966,
    10967,
    6507,
    6508,
    6509,
    11578,
    8957,
    10371,
    10257,
    9902,
    127768,
    127769,
    10411,
    11097,
    10151,
    14522,
    131367,
    131368,
    9014,
    133011,
    133817,
    8943,
    140477,
    10198,
    8942,
    8934,
];
var HANDICAP_MARKET_TYPES = [
    '5503', '5504', '6500', '8724', '8956', '8962', '8963', '9017', '9019', '9021',
    '9023', '9649', '10046', '10257', '10350', '10822', '10911', '11035', '11049', '11214', '14170',
];
export function NewEventDetail() {
    var _a;
    var marketGroups = [];
    var eventMarkets = [];
    var eventMarketMapping = {};
    var forceUpdate = useForceUpdate();
    var _b = useState('Tümü'), showMarketGroup = _b[0], setShowMarketGroup = _b[1];
    var _c = useState(new Set()), manuallyClosed = _c[0], setManuallyClosed = _c[1];
    var _d = useState(new Set()), manuallyOpened = _d[0], setManuallyOpened = _d[1];
    var t = useTranslation().t;
    useEffect(function () {
        var betSlipSub = betSlipActionSubject.subscribe(function (ev) {
            var _a;
            if (typeof ev === 'object' && event) {
                if (['remove', 'toggle'].includes(ev.action) && ((_a = ev.betSlip.sportEvent) === null || _a === void 0 ? void 0 : _a.eventId) === event.eventId) {
                    forceUpdate();
                }
            }
        });
        var eventUpdateSub = eventUpdateSubject.subscribe(function (events) {
            if (event && events.includes(event.eventId)) {
                clearTimeout(updateTimer);
                updateTimer = setTimeout(function () { return forceUpdate(); }, 300);
            }
        });
        return function () {
            betSlipSub.unsubscribe();
            eventUpdateSub.unsubscribe();
            clearTimeout(updateTimer);
        };
    }, []);
    useEffect(function () {
        var detailSub = eventDetailSubject.subscribe(function (res) {
            event = res;
            if (res && res !== 'toggle') {
                setShowMarketGroup('Tümü');
                eventDetailVisiblity.visible = true;
                forceUpdate();
            }
            else {
                event = null;
                eventDetailVisiblity.visible = false;
                forceUpdate();
            }
        });
        return function () {
            detailSub.unsubscribe();
            event = null;
        };
    }, []);
    useEffect(function () {
        if (!event)
            return;
        getEvent(event.eventId).then(function (res) {
            var _a;
            if (!res)
                return;
            compireEventKeys(eventMapping[event.eventId], res);
            if (!marketIdMapping[event.eventId]) {
                marketIdMapping[event.eventId] = {};
            }
            else {
                eventMapping[event.eventId].hasCustomratio = false;
            }
            for (var _i = 0, _b = res.markets; _i < _b.length; _i++) {
                var market = _b[_i];
                var current = marketIdMapping[event.eventId][market.marketId];
                if (current) {
                    compireMarketKeys(eventMapping[event.eventId], current, market);
                }
                else {
                    marketIdMapping[event.eventId][market.marketId] = market;
                    marketMapping[event.eventId].push(market);
                    checkAndAddHighLightedMarkets(eventMapping[event.eventId.toString()], marketIdMapping[event.eventId][market.marketId]);
                }
            }
            if (!((_a = eventMapping[event.eventId].highlightedMarkets) === null || _a === void 0 ? void 0 : _a.length)) {
                fillHighLightedMarkets(eventMapping[event.eventId]);
            }
            forceUpdate();
        });
    }, [event]);
    if (!event)
        return _jsx(_Fragment, {}, void 0);
    if (event.liveScoreStatus && event.mPT && event.cur) {
        var timeStatuses = ['520', '521', '522', '523', '700'];
        event.minute = timeStatuses.includes(String(event.liveScoreStatus))
            ? event.mPT + '.dk'
            : LiveScoreStatusType[Number(event.liveScoreStatus)];
    }
    eventMarkets = marketMapping[event.eventId].filter(function (el) { return el.mS < 2 && el.mS !== 0; });
    marketGroups = marketCategories[event.sS];
    for (var _i = 0, eventMarkets_1 = eventMarkets; _i < eventMarkets_1.length; _i++) {
        var m = eventMarkets_1[_i];
        if (!eventMarketMapping[m.mST])
            eventMarketMapping[m.mST] = [];
        eventMarketMapping[m.mST].push(m);
    }
    var team1Name = getFromLanguageFile(event.eP[0].nameId) || event.eP[0].participantName;
    var team2Name = event.eP.length > 1
        ? (getFromLanguageFile(event.eP[1].nameId) || event.eP[1].participantName)
        : '';
    var eDate = new Date(event.eD);
    var formattedDate = "".concat(eDate.getDate().toString().padStart(2, '0'), "/").concat((eDate.getMonth() + 1).toString().padStart(2, '0'), " ").concat(eDate.getHours().toString().padStart(2, '0'), ":").concat(eDate.getMinutes().toString().padStart(2, '0'));
    var getMarketName = function (market) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            var lang = getFromLanguageFile(market.nId);
            if (lang) {
                return lang
                    .replaceAll('{pw}', (_a = market.pS) !== null && _a !== void 0 ? _a : '')
                    .replaceAll('{sw}', (_b = market.s) !== null && _b !== void 0 ? _b : '')
                    .replaceAll('{s}', (_c = market.s) !== null && _c !== void 0 ? _c : '')
                    .replaceAll('{p}', (_d = market.pS) !== null && _d !== void 0 ? _d : '')
                    .replaceAll('{t1}', getFromLanguageFile(event.eP[0].nameId) || event.eP[0].participantName)
                    .replaceAll('{t2}', event.eP.length > 1 ? (getFromLanguageFile(event.eP[1].nameId) || event.eP[1].participantName) : '')
                    .replaceAll('{h}', (_e = market.sOV) !== null && _e !== void 0 ? _e : '')
                    .replaceAll('{hv}', (_f = market.hV) !== null && _f !== void 0 ? _f : '')
                    .replaceAll('{av}', (_g = market.aV) !== null && _g !== void 0 ? _g : '');
            }
        }
        catch (_h) {
        }
        return market.mN;
    };
    var getHcpLineLabel = function (sOV) {
        return sOV < 0 ? "(".concat(Math.abs(sOV), ":0)") : "(0:".concat(sOV, ")");
    };
    var renderMarkets = function (marketsList) {
        var sortedMarkets = __spreadArray([], eventMarkets, true).sort(function (a, b) {
            var ai = MARKET_ORDER.indexOf(Number(a.mST));
            var bi = MARKET_ORDER.indexOf(Number(b.mST));
            if (ai === -1 && bi === -1)
                return 0;
            if (ai === -1)
                return 1;
            if (bi === -1)
                return -1;
            return ai - bi;
        });
        var available = sortedMarkets.filter(function (m) {
            var _a;
            if (['5520', '5500'].includes(m.mST) && !isHalfNumber((_a = m.marketOutcome[0]) === null || _a === void 0 ? void 0 : _a.oN))
                return; // if Total Goals (5500) is not half number skip it.
            return (marketsList.length === 0 || marketsList.includes(m.mST)) && m.mS < 2;
        });
        available.forEach(function (m) {
            m.sOV = Number(m.sOV);
        });
        var seen = new Set();
        var groupKeys = [];
        for (var _i = 0, available_1 = available; _i < available_1.length; _i++) {
            var m = available_1[_i];
            if (!seen.has(m.mST)) {
                seen.add(m.mST);
                groupKeys.push(m.mST);
            }
        }
        return groupKeys.map(function (mST, gi) {
            var markets = available.filter(function (m) { return m.mST === mST; });
            var isHandicapGroup = HANDICAP_MARKET_TYPES.includes(mST);
            if (isHandicapGroup)
                markets.sort(function (a, b) { return a.sOV - b.sOV; });
            var first = markets[0];
            var outcomeCount = first.marketOutcome.length;
            var colCount = outcomeCount > 3 ? '2' : outcomeCount === 2 ? '2' : '3';
            var renderHcpCard = function () {
                console.log('renderHcpCard', markets);
                return (_jsx("div", __assign({ className: "ned-hcp-card" }, { children: markets.map(function (market, mi) { return (_jsxs("div", __assign({ className: "ned-hcp-row" }, { children: [_jsx("span", __assign({ className: "ned-hcp-line-label" }, { children: getHcpLineLabel(market.sOV) }), void 0), _jsx("div", __assign({ className: "ned-hcp-cells" }, { children: _jsx(Odd, { event: event, market: market, hcpStyle: true }, void 0) }), void 0)] }), mi)); }) }), void 0));
            };
            if (isMobileView) {
                var isOpen_1 = gi <= 10
                    ? !manuallyClosed.has(mST) // ilk 10: default açık, kapatılabilir
                    : manuallyOpened.has(mST); // 10 sonrası: default kapalı, açılabilir
                return (_jsxs("div", __assign({ className: "ned-market-column" }, { children: [_jsxs("div", __assign({ className: "ned-market-info", onClick: function () {
                                if (isOpen_1) {
                                    if (gi <= 10)
                                        setManuallyClosed(function (prev) { return new Set(prev).add(mST); });
                                    else
                                        setManuallyOpened(function (prev) {
                                            var s = new Set(prev);
                                            s.delete(mST);
                                            return s;
                                        });
                                }
                                else {
                                    if (gi <= 10)
                                        setManuallyClosed(function (prev) {
                                            var s = new Set(prev);
                                            s.delete(mST);
                                            return s;
                                        });
                                    else
                                        setManuallyOpened(function (prev) { return new Set(prev).add(mST); });
                                }
                            } }, { children: [_jsx("span", __assign({ className: "ned-info-icon" }, { children: "\u24D8" }), void 0), _jsx("div", __assign({ className: "ned-market-name-wrap" }, { children: _jsx("span", __assign({ className: "ned-market-name" }, { children: getMarketName(first) }), void 0) }), void 0), _jsxs("div", __assign({ className: "d-flex" }, { children: [!isOpen_1 && (_jsx("span", { className: "sp-s-l-h-arrow-icon-bc bc-i-small-arrow-up" }, void 0)), isOpen_1 && (_jsx("span", { className: "sp-s-l-h-arrow-icon-bc bc-i-small-arrow-down" }, void 0))] }), void 0)] }), void 0), isOpen_1 && (_jsx("div", __assign({ className: "ned-odds-container" }, { children: isHandicapGroup ? renderHcpCard() : (markets.map(function (market, mi) { return (_jsx("div", __assign({ className: "sgm-market-g-item-bc column-".concat(colCount) }, { children: _jsx(Odd, { event: event, market: market, showOutcomeName: true }, void 0) }), mi)); })) }), void 0))] }), gi));
            }
            return (_jsxs("div", __assign({ className: "ned-market-row" }, { children: [_jsxs("div", __assign({ className: "ned-market-info" }, { children: [_jsx("span", __assign({ className: "ned-info-icon" }, { children: "\u24D8" }), void 0), _jsx("div", __assign({ className: "ned-market-name-wrap" }, { children: _jsx("span", __assign({ className: "ned-market-name" }, { children: getMarketName(first) }), void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: "ned-odds-container" }, { children: isHandicapGroup ? renderHcpCard() : (markets.map(function (market, mi) { return (_jsx("div", __assign({ className: "sgm-market-g-item-bc column-".concat(colCount) }, { children: _jsx(Odd, { event: event, market: market, showOutcomeName: true }, void 0) }), mi)); })) }), void 0)] }), gi));
        });
    };
    return (_jsxs("div", __assign({ className: "ned-container" }, { children: [_jsxs("div", __assign({ className: "ned-header" }, { children: [_jsxs("div", __assign({ className: "ned-header-row" }, { children: [_jsx("div", __assign({ className: "ned-team-box" }, { children: team1Name }), void 0), _jsx("div", __assign({ className: "ned-score-col" }, { children: _jsx("span", __assign({ className: "ned-score" }, { children: (_a = event.cur) !== null && _a !== void 0 ? _a : '-:-' }), void 0) }), void 0), _jsx("div", __assign({ className: "ned-team-box" }, { children: team2Name }), void 0), _jsx("button", __assign({ className: "ned-stat-btn", "aria-label": "Statistics", onClick: function () {
                                } }, { children: _jsxs("svg", __assign({ width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round" }, { children: [_jsx("rect", { x: "18", y: "3", width: "4", height: "18", rx: "1" }, void 0), _jsx("rect", { x: "10", y: "8", width: "4", height: "13", rx: "1" }, void 0), _jsx("rect", { x: "2", y: "13", width: "4", height: "8", rx: "1" }, void 0)] }), void 0) }), void 0)] }), void 0), _jsx("div", __assign({ className: "ned-header-date" }, { children: event.mPT ? (event.minute || event.mPT) : formattedDate }), void 0)] }), void 0), _jsx("div", __assign({ className: "ned-tabs" }, { children: marketGroups.map(function (group, gi) {
                    var count = group.name === 'Tümü'
                        ? Object.keys(eventMarketMapping).length
                        : group.markets.filter(function (el) { return eventMarketMapping[el]; }).length;
                    if (group.name !== 'Tümü' && count === 0)
                        return null;
                    return (_jsx("button", __assign({ className: "ned-tab".concat(showMarketGroup === group.name ? ' ned-tab-active' : ''), onClick: function () { return setShowMarketGroup(group.name); } }, { children: t(group.name) }), gi));
                }) }), void 0), _jsx("div", __assign({ className: "ned-markets-list" }, { children: marketGroups.map(function (group, gi) {
                    if (group.name !== showMarketGroup)
                        return null;
                    return (_jsx("div", { children: renderMarkets(group.name === 'Tümü' ? [] : group.markets) }, gi));
                }) }), void 0)] }), void 0));
}
